import { cn } from '@heroui/react';
import {
  HEADER_HEIGHT,
  NAVIGATION_BAR_HEIGHT,
} from '@school-manage/common/constants';
import { createElement, type HTMLAttributes, type ReactNode } from 'react';

interface Props<T extends keyof JSX.IntrinsicElements>
  extends HTMLAttributes<T> {
  as?: T;
  children: ReactNode;
  className?: string;
  hasHeaderGap?: boolean;
  hasNavigationGap?: boolean;
}

export function Container<T extends keyof JSX.IntrinsicElements = 'div'>({
  as = 'div' as T,
  children,
  className = undefined,
  hasHeaderGap = true,
  hasNavigationGap = true,
  ...props
}: Props<T>) {
  return createElement(
    as,
    {
      className: cn(
        'bg-background mx-auto flex w-full max-w-4xl flex-col gap-y-4 p-[16px] transition-[background-color] duration-300 md:gap-y-8',
        className
      ),
      style: {
        marginBottom: hasNavigationGap ? NAVIGATION_BAR_HEIGHT + 64 : 0,
        marginTop: hasHeaderGap ? HEADER_HEIGHT : 0,
      },
      ...props,
    },
    children
  );
}
